export const billingInfoAdapter = (billingInfo) => {
	return [
		{
			first_name: billingInfo?.first_name || '-',
			last_name: billingInfo?.last_name || '-',
			email: billingInfo?.email || '-',
			phone: billingInfo?.phone || '-',
			sex: billingInfo?.sex || '-',
			rfc: billingInfo?.rfc || '-',
			rut: billingInfo?.rut || '-',
			street: billingInfo?.street || '-',
			street_number: billingInfo?.street_number || '-',
			between_street: billingInfo?.between_street || '-',
			type_house: billingInfo?.type_house || '-',
			province: billingInfo?.province || '-',
			commune: billingInfo?.commune || '-',
			zip_code: billingInfo?.zip_code || '-',
			country: billingInfo?.country || '-',
			reference: billingInfo?.reference || '-',
      cfdi: billingInfo?.cfdi || '-',
      colony: billingInfo?.colony || '-',
      number_dpto_house: billingInfo.number_dpto_house || '-'
		},
	];
};
